// Module
var code = "<mx-text-box ng-if=\"vm.isString()\" data-value=\"vm.entity[vm.field.name]\" aria-label=\"{{vm.field.title}}\" data-label=\"{{vm.field.title}}\"></mx-text-box>\r\n<md-checkbox ng-if=\"vm.isBool()\" ng-model=\"vm.entity[vm.field.name]\" aria-disabled=\"true\"><label>{{vm.field.title}}</label></md-checkbox>";
// Exports
export default code;